function stripTrailingSlashes(value: string): string {
  return value.replace(/\/+$/g, '');
}

export function getApiOrigin(): string {
  const fromEnv = (process.env.REACT_APP_API_URL || '').trim();
  if (fromEnv) return stripTrailingSlashes(fromEnv);

  const isProduction = process.env.NODE_ENV === 'production';
  if (isProduction) {
    return 'https://api.appshow.live';
  }

  // Default for local development
  return 'http://localhost:4000';
}

export const API_ORIGIN = getApiOrigin();
export const API_BASE_URL = API_ORIGIN;
export const API_BASE_URL_API = `${API_ORIGIN}/api`;
